import i18n from '@/i18n.js';

// Krátký datum se zkratkou dne podle jazyka aplikace, např. „Po 12. 10. 2026“ / „Mon 12. 10. 2026“.
// Dřív bylo pole českých zkratek ['Ne', 'Po', …] zkopírované v 8 komponentách a EN verze je ukazovala česky.
// Číselná část zůstává ve stejném formátu, aby se neměnil vzhled.
export function formatDateShort(dateStr) {
    const d = new Date(dateStr);
    const weekday = new Intl.DateTimeFormat(i18n.global.locale, { weekday: 'short' }).format(d);
    const day = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    return `${day} ${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}
